<script setup>
import { computed } from 'vue'
import { useProfileStore } from '@/stores/profile'
import UTAUsers from '@/components/UTAUsers.vue'
import UTAUsersGroups from '@/components/groupsUsers/UTAUsersGroups.vue'

const profileStore = useProfileStore()
const profile = computed(() => profileStore.profile)

</script>

<template>
    <div class="page page--users">
        <UTAUsers />
        <UTAUsersGroups v-if="profile.attr?.array.includes('SUPER_ADMIN')" />
    </div>
</template>
